import React, {useEffect, useLayoutEffect, useState, useRef} from "react";
import Ows from "../../utils/OwsHandler";
//import CandidateWorkExperience from "../candidate/CandidateWorkExperiance";
//import CandidateEducationHistory from "../candidate/CandidateEducationHistory";
//import CandidateTable from "../candidate/CandidateTable";
//import ProcedureRelationTable from "./ProcedureRelationTable";
//import ProcedureVacancyTable from "./ProcedureVacancyTable";
import RelationContactTable from "./RelationContactTable";
import RelationContactRelationTable from "./RelationContactRelationTable";
import {
    Tab,
    TabList,
    makeResetStyles, 
    makeStyles,
    shorthands
  } from "@fluentui/react-components"; 
import {
    Person24Filled,
    Person24Regular,
    Briefcase24Filled,
    Briefcase24Regular,
    Patient24Filled,
    Patient24Regular,
    bundleIcon,
  } from "@fluentui/react-icons";
import { customTokens } from "../../utils/Theming";
import useSize from "@react-hook/size";

const Person24 = bundleIcon(Person24Filled, Person24Regular);
const Briefcase24 = bundleIcon(Briefcase24Filled, Briefcase24Regular);
const Patient24 = bundleIcon(Patient24Filled, Patient24Regular);

const useBaseClassName = makeResetStyles({
    ...shorthands.padding(customTokens.spacingVerticalMNudge, customTokens.spacingHorizontalL, 0)
});
const useStyles = makeStyles({
   firstTabsRow: {
        backgroundColor: customTokens.colorTabsBackground1,
   }
});

export default function RelationContactInfo({relationContact, onAddTabs}) {
    const target = useRef(null);
    const baseClassName = useBaseClassName();
    const classes = useStyles();

    //const [candidate, setCandidate] = useState(null);

    const [selectedValue, setSelectedValue] = useState('tab2');
    const [selectedSubValue, setSelectedSubValue] = useState('subtab1');
    const [width, ] = useSize(target);
    let tablistVertical = true;
    if (width > 450) {
        tablistVertical = false;
    }

    let tabExperienceText = 'Work exp.';
    let tabEducationText = 'Edu hist.';
    if (width > 400) {
        tabExperienceText = 'Work Experience';
        tabEducationText = 'Education History';
    }
    
    let tablistSize = 'small';
    if (width > 275){
        tablistSize = 'medium'
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [selectedValue, selectedSubValue]);

console.log('RelationContactInfo p2', relationContact);

    /*
    useEffect(() => {
        (async () => {
            const {response: candidateDetail} = await Ows.handleRequest(
                'Otys.Services.CandidateService.getDetail',
                [
                    procedure.candidateUid,
                    {
                        EducationHistory: {
                            uid: true,
                            degree: true,
                            startDateFormatted: true,
                            endDateFormatted: true,
                            subjects: true,
                            institute: true,
                            diplomaDate: true,
                        },
                        EmploymentHistory: {
                            uid: true,
                            experience: true,
                            startDateFormatted: true,
                            endDateFormatted: true,
                            employerNameAndPlace: true,
                            description: true,
                        }
                    }
                ]
            );
            setCandidate(candidateDetail);
        })();
    }, [procedure.candidateUid]);
    */

    useLayoutEffect(() => {
        onAddTabs(
            <>
                {selectedValue === 'tab2' && 
                    <div className={classes.firstTabsRow}>
                        <TabList selectedValue={selectedSubValue} onTabSelect={(e, {value}) => setSelectedSubValue(value)} vertical={tablistSize}>
                            <Tab icon={<Person24 />} value="subtab1">Contact details</Tab>
                            <Tab icon={<Patient24 />} value="subtab2">Relation details</Tab>                
                        </TabList>
                    </div>
                }
            </>
        );

        return () => {
            onAddTabs(null);
        };
    }, [selectedValue, selectedSubValue, tablistVertical, tabEducationText, tabExperienceText, tablistSize, onAddTabs, classes.firstTabsRow]);

    const renderTab = () => {
        switch (selectedValue) {
            case 'tab1':
                switch (selectedSubValue) {
                    case 'subtab1':
                        //return <CandidateTable data={procedure.Candidate} context='procedure'></CandidateTable>;
                    case 'subtab2':
                        //return <CandidateWorkExperience data={candidate.EmploymentHistory}></CandidateWorkExperience>;
                    case 'subtab3':
                        //return <CandidateEducationHistory data={candidate.EducationHistory}></CandidateEducationHistory>;
                    default:
                        return null;
                }
            case 'tab2':
                switch (selectedSubValue) {
                    case 'subtab1':
                        return <RelationContactTable relationContact={relationContact}></RelationContactTable>;
                    case 'subtab2':
                        return <RelationContactRelationTable relationContact={relationContact}></RelationContactRelationTable>;
                    case 'subtab3':
                        //return <CandidateEducationHistory data={candidate.EducationHistory}></CandidateEducationHistory>;
                    default:
                        return null;
                }                
            case 'tab3':                
                //return <ProcedureRelationTable ooid={procedure.Vacancy.relationId} ooidc={procedure.Vacancy.relationContactId}></ProcedureRelationTable>;
            default:
                return null;
        }
    
    };

    return (
        <div className={baseClassName} ref={target}>
                {renderTab()}
        </div>
    );
}  